import React, { useState, useEffect } from "react";
import {
  HistoryOutlined,
  PlusCircleOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import "./index.scss";

interface SidebarProps {
  onHistoryClick: () => void;
  onEditClick: () => void;
  onNewCanvasClick?: () => void;
  isHistoryDrawerOpen: boolean;
  preChatToggle?: {
    visible: boolean;
    onClick: () => void;
  };
}

const Sidebar: React.FC<SidebarProps> = ({
  onHistoryClick,
  onNewCanvasClick,
  isHistoryDrawerOpen,
  preChatToggle,
}) => {
  const [activeIcon, setActiveIcon] = useState<
    "edit" | "history" | "new-canvas" | null
  >(onNewCanvasClick ? "new-canvas" : null);

  // Reset to new-canvas icon when history drawer closes
  useEffect(() => {
    if (!isHistoryDrawerOpen && activeIcon === "history") {
      setActiveIcon(onNewCanvasClick ? "new-canvas" : null);
    }
  }, [isHistoryDrawerOpen, activeIcon, onNewCanvasClick]);

  const handleHistoryClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();
    setActiveIcon("history");
    onHistoryClick();
  };

  const handleNewCanvasClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.blur();
    setActiveIcon("new-canvas");
    onNewCanvasClick?.();
    // Reset to new-canvas mode after creating new canvas
    setTimeout(() => setActiveIcon("new-canvas"), 200);
  };

  return (
    <div className="conversation-sidebar">
      <div className="sidebar-icon-container">
        {onNewCanvasClick && (
          <button
            className={`sidebar-icon ${activeIcon === "new-canvas" ? "active" : ""}`}
            onClick={(e) => handleNewCanvasClick(e)}
            title="New Wavvest Planning"
          >
            <PlusCircleOutlined />
          </button>
        )}
        <button
          className={`sidebar-icon ${activeIcon === "history" ? "active" : ""}`}
          onClick={(e) => handleHistoryClick(e)}
          title="View History"
        >
          <HistoryOutlined />
        </button>

        {preChatToggle?.visible && (
          <button
            className="sidebar-icon"
            onClick={(e) => {
              e.currentTarget.blur();
              preChatToggle.onClick();
            }}
            title="Back to pre-chat"
            aria-label="Back to pre-chat"
          >
            <RollbackOutlined />
          </button>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
